import type { Logger } from '@vp/ubik-logging'

import type { Breadcrumb } from '../types/Breadcrumbs'
import { REQUESTOR } from '../utils/constants'

const baseUrl = 'https://url-metadata.prod.merch.vpsvc.com'

export const getBreadcrumbs = async (tenant: string, culture: string, mpvId: string, logger: Logger): Promise<Breadcrumb[]> => {
  try {
    const url = `${baseUrl}/v1/breadcrumbs/${tenant}/${culture}/${mpvId}/?requestor=${REQUESTOR}`
    const response = await fetch(url)

    if (!response.ok) {
      throw new Error(`Request to ${url} failed with status: ${response.status}`)
    }

    const data = (await response.json()) as Breadcrumb[]
    return data
  } catch {
    logger.warn(`Unable to retrieve breadcrumbs for ${mpvId} in ${culture}.`)
    return []
  }
}
